import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { NICHES } from "@/lib/siteData";

const NicheCard = ({ niche, variant = "default" }) => {
  const isWide = variant === "wide";
  return (
    <article
      data-testid={`niche-card-${niche.id}`}
      className={`group relative rounded-3xl bg-[#1E2A1E] border border-[#E3A21A]/10 overflow-hidden transition-all duration-500 hover:border-[#E3A21A]/40 ${niche.span}`}
    >
      {/* Image backdrop */}
      <div className={`relative overflow-hidden ${isWide ? "h-[280px] md:h-[320px]" : "h-56"}`}>
        <img
          src={niche.image}
          alt={niche.name}
          className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E2A1E] via-[#1E2A1E]/30 to-transparent" />
        <div className="absolute top-5 left-5">
          <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#E3A21A] bg-[#121A12]/80 backdrop-blur-md px-3 py-1.5 rounded-full border border-[#E3A21A]/25">
            {niche.eyebrow}
          </span>
        </div>
        <div className="absolute bottom-5 right-5">
          <div className="h-12 w-12 rounded-full bg-[#E3A21A] text-[#121A12] flex items-center justify-center group-hover:rotate-45 transition-transform duration-500">
            <ArrowUpRight className="h-5 w-5" />
          </div>
        </div>
      </div>

      <div className="p-8 md:p-10">
        <h3 className="font-display text-3xl md:text-4xl text-[#F5F5F0] tracking-tight font-medium">
          {niche.name}
          <span className="text-[#E3A21A]">.</span>
        </h3>
        <p className="mt-3 text-[#A8B8A8] text-base leading-relaxed max-w-xl">
          {niche.headline}
        </p>

        <ul className="mt-6 space-y-2.5">
          {niche.points.map((p, i) => (
            <li key={i} className="flex items-start gap-3 text-sm text-[#F5F5F0]/90">
              <CheckCircle2 className="h-4 w-4 text-[#E3A21A] mt-0.5 flex-shrink-0" />
              <span>{p}</span>
            </li>
          ))}
        </ul>

        <div className="mt-6 pt-5 border-t border-[#E3A21A]/10 flex items-center gap-2">
          <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#E3A21A]">
            Result →
          </span>
          <span className="text-sm text-[#F5F5F0] font-medium">{niche.result}</span>
        </div>
      </div>
    </article>
  );
};

export const NicheExpertise = () => {
  return (
    <section
      id="niches"
      data-testid="niches-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#E3A21A] mb-4">
            Niche Expertise
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] font-medium">
            Built for three industries.{" "}
            <span className="text-[#A8B8A8]">
              Not another "we do everything" agency.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          <NicheCard niche={NICHES[0]} />
          <NicheCard niche={NICHES[1]} />
          <NicheCard niche={NICHES[2]} variant="wide" />
        </div>
      </div>
    </section>
  );
};
